module.exports = __webpack_public_path__ + "static/media/profile-founder.65eb4759.jpg";